import View from "backdraft-app/src/view";

import _ from "underscore";

const DEFAULT_JST_DELIMS = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
};

const template = _.template('<select name="<%= selectName %>" class="form-control" data-mount="time-zone-select"></select>', null, DEFAULT_JST_DELIMS);

export default class TimeZoneSelect extends View {
  initialize(priorityZones, otherZones, selectedZone, selectName) {
    this.priorityZones = priorityZones;
    this.otherZones = otherZones;
    this.selectedZone = selectedZone;
    this.selectName = selectName;
  }

  render() {
    this.$el.html(template({ selectName: this.selectName || 'timezone' }));
    this._buildSelect();

    return this;
  }

  getSelectedTimeZone() {
    return this.$("[data-mount='time-zone-select']").val();
  }

  _buildSelect() {
    const timeZoneSelect = this.$("[data-mount='time-zone-select']");
    const selectOptions = this._buildOptions();

    timeZoneSelect.select2({
      data: selectOptions
    });
  }

  _buildOptions() {
    let options = [];

    options = this._addSelectOptions(options, this.priorityZones, false);
    options = this._addSelectOptions(options, [{ "offset": "", "name": "--------------------------------------" }], true);
    options = this._addSelectOptions(options, this.otherZones, false);

    return options;
  }

  _addSelectOptions(options, newOptions, disabled) {
    newOptions.forEach(({ offset, name }) => {
      const isSelected = (offset === this.selectedZone.offset && name === this.selectedZone.name);
      const zoneOption = this._zoneOption(offset, name, isSelected, disabled);
      options.push(zoneOption);
    });

    return options;
  }

  _zoneOption(offset, name, selected, disabled) {
    const zoneDisplay = `${offset} ${name}`;

    return { id: name, text: zoneDisplay, selected, disabled };
  }
}
